import React, { useEffect, useState } from 'react';
import CheckboxComponent from '../../../../commons/components/Forms/CheckboxComponent';
import Button from '../../../../commons/components/Button';
import {STEPS, TEMPLATE_CASE, TEMPLATE_CODE} from '../../../../commons/constans/stepVideo';
import { useSelector } from 'react-redux';
import ButtonComponent from '../../../../commons/components/Forms/ButtonComponent';
import TextareaComponent from '../../../../commons/components/Forms/TextareaComponent';
import { replaceNameInTemplate } from '../../../../utils/helpers';
import { useUser } from '../../../../commons/customHooks/Account';

type Props = {
  pushDataVideoStepThree: Function,
  pushDataVideoStepTwo: Function,
  steps: Object,
  goToSteps: Function,
};

const Step3Component = ({
  pushDataVideoStepThree,
  pushDataVideoStepTwo,
  steps,
  goToSteps,
}: Props) => {

  const { user } = useUser()
  const [dataStep3, setDataStep3] = useState({
    step_3: {
      confirm_step_3: true,
      content_step3: ''
    },
  });

  useEffect(() => {
    scrollTo(0, 0);
    setDataStep3({
      step_3: steps.step_3,
    });
    let content_result =  replaceNameInTemplate(TEMPLATE_CODE, steps.step_1?.character_pose_name, steps.step_2.code, TEMPLATE_CASE, steps.step_2.child_name);
    pushDataVideoStepTwo({
      ...steps,
      step_2: {
        ...steps.step_2,
        content: content_result.content,
      },
    }, STEPS.TWO);
    setDataStep3({
      ...dataStep3,
      step_3: {
        content_step3: content_result.contentHighLight,
      },
    })
  }, []);

  useEffect(() => {
    pushDataVideoStepThree(dataStep3, STEPS.THREE);
  }, [dataStep3]);

  const handleChangeCheckBox = (e) => {
    setDataStep3({
      ...dataStep3,
      step_3: {
        ...dataStep3.step_3,
        [e.target.name]: e.target.checked,
      },
    });
  };

  const goToStep = (step) => {
    goToSteps(step);
  };

  const convertToWord = (data) => {
    return data.replace(/\r?\n/g,"\<br />");
  }

  return (
    <>
      <h3>
        영상에 들어갈 <span>{' '}문구를 확인</span>해주세요!
      </h3>
      <div className="step-notification">
        <div className="warning text-center">
          <div className="img">
            <img src="/images/icon_caution.svg" alt="warning" />
          </div>
          <div className="description">
            영상 제작이 시작되면 <br />
            문구 변경이 어렵습니다!
          </div>
        </div>
        <div className="box-note">
          <h4 className='title-video'>{user?.nickname || ''} 님의 요청 영상문구</h4>
          {/* <div className="description" dangerouslySetInnerHTML={{__html: steps?.step_2?.contentShow}}></div> */}
          <div className='box-content-template-step3'>
            <div className="img-position">
              <img src="/images/template.png" alt="" />
            </div>
            <div className="content-template-step3">
              <div className="content-dialog">
                <div
                  contenteditable={'false'}
                  id="text-template"
                  className="content-template-popup"
                  dangerouslySetInnerHTML={{
                    __html: dataStep3.step_3.content_step3 || '',
                  }}
                >
                </div>
              </div>
            </div>
          </div>
          
         
          
          {/* <CheckboxComponent
            id={'js-confirm-step-3'}
            name={'confirm_step_3'}
            value={dataStep3.step_3.confirm_step_3}
            disabled={false}
            subTitle={'요청하신 문구가 올바르게 입력되었습니까?'}
            labelClass={'d-flex align-start'}
            checked={dataStep3.step_3?.confirm_step_3 ? true : false}
            handleChange={handleChangeCheckBox}
          /> */}
        </div>
        <div className="button">
          {/* <Button onClick={() => goToStep(STEPS.TWO)} customClass="prev">
            이전 단계{" "}
          </Button>
          <Button onClick={() => goToStep(STEPS.FOUR)}>다음 단계 </Button> */}

          <ButtonComponent
            label={`이전 단계`}
            customClass="btn btn-default"
            handleClick={() => goToStep(STEPS.TWO)}
            type={`button`}
            cssClass={`prev`}
          />
          <ButtonComponent
            label={`다음 단계`}
            customClass="btn btn-default"
            handleClick={() => goToStep(STEPS.FOUR)}
            type={`button`}
            // disabled={!dataStep3.step_3.confirm_step_3}
          />
        </div>
      </div>
    </>
  );
};

export default Step3Component;
